import { render, staticRenderFns } from "./VendorViewModal.vue?vue&type=template&id=51b5d3f0&"
import script from "./VendorViewModal.vue?vue&type=script&lang=js&"
export * from "./VendorViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports